// extracted by mini-css-extract-plugin
module.exports = {"commentBox":"CommentBox_commentBox__lAiCW","commentArea":"CommentBox_commentArea__3enFq","notLoggedText":"CommentBox_notLoggedText__YPIsW"};